import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, useNavigate } from 'react-router';
// import history from '../../history';

import auth from '../../auth';
import Loading from '../../components/Loading/Loading';
import {I18n, Translate} from 'react-redux-i18n';
import style from './Companies.module.css';

import {
  fetchCompanies as fetchCompaniesAction,
  exportAll as exportAllAction,
  exportCompanies as exportCompaniesAction,
  deleteCompanies as deleteCompaniesAction,
  importFile as importFileAction
} from './CompaniesActions';

function Companies(props) {
  const {
    loading,
    companies,
    fetchCompanies,
    deleteCompanies,
    exportCompanies,
    exportAll: exportAllProp, // Rename to avoid conflict with function name
    importFile: importFileProp
  } = props;

  const navigate = useNavigate();

  const [selected, setSelected] = useState([]);
  const [filter, setFilter] = useState({
    limit: 25,
    name: ''
  });

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  function handleDelete() {
    deleteCompanies(selected);
  }

  function handleExport() {
    exportCompanies(selected);
  }

  function handleExportAll() {
    exportAllProp();
  }
  
  function changeFilter(e) {
    const newFilter = { ...filter, [e.target.id]: e.target.value };
    setFilter(newFilter);
  }

  function importFile(e) {
    let file = e.target.files[0];
    if (file) {
      if (file.size > process.env.MAX_UPLOAD_MB * 1024 * 1024) {
        alert('File is to big. Maximum uploading file is ' + process.env.MAX_UPLOAD_MB + 'MB')
      }
      else {
        importFileProp(file);
      }
    }
  }

  function createCompany() {
    navigate('/company');
  }

  function selectCompany(selectingCompanyId) {
    let newSelected = [...selected];
    let index = newSelected.indexOf(selectingCompanyId);

    if (index >= 0) {
      newSelected.splice(index, 1);
    }
    else {
      newSelected.push(selectingCompanyId);
    }

    setSelected(newSelected);
  }

  function showMore() {
    let doc = document.documentElement;
    let top = (window.pageYOffset || doc.scrollTop)  - (doc.clientTop || 0);
    
    setFilter(prev => ({ ...prev, limit: prev.limit + 25 }));
    
    window.scrollTo(0, top);

    setTimeout(()=>{
    window.scrollTo(0, top);
    }, 1)
  }

  let allCompanies = companies.slice();
  let filterNameUpCase = filter.name.toUpperCase();

  let filteredCompanies = allCompanies.filter(company => {
      return (company.name.toUpperCase().indexOf(filterNameUpCase) >= 0);
  });
  
  let showShowMore = filter.limit < filteredCompanies.length;
  filteredCompanies = filteredCompanies.slice(0, filter.limit);
  
  const isMaster = auth.can('exercise-master');
  const name = filter.name;

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        { loading && <Loading /> }
        <h3><strong><Translate value="companies.title"/></strong></h3>
        <hr />
        <Translate value="companies.desc"/><br/>
        <input style={{display:'none'}} id="import-file-input" type="file" onChange={importFile}/>
        <label className="btn btn-primary" htmlFor="import-file-input">Import</label>
        &nbsp;
        <button className="btn btn-primary" onClick={handleDelete}>
          <i className="fas fa-trash" /> <Translate value="create.Delete"/>
        </button>&nbsp;
        <button className="btn btn-primary" onClick={handleExport}>
          <i className="fas fa-download" /> <Translate value="create.Export"/>
        </button>&nbsp;
        <button className="btn btn-primary" onClick={handleExportAll}>
          <i className="fas fa-download" /> <Translate value="create.ExportAll"/>
        </button>&nbsp;
        <button className="btn btn-primary" onClick={createCompany}>
          <i className="fas fa-plus" /> <Translate value="create.CreateCompany"/>
        </button>
        { isMaster &&
          <div className={style.filterWrapper}>
            <p className={style.title}><Translate value="controls.Filters"/></p>
            <div className={style.filter}>
              <div className="d-flex">
                <div className="mb-3">
                  <label className="control-label" htmlFor="name"><Translate value="create.CompanyName"/></label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value={name}
                    onChange={changeFilter}
                  />
                </div>
              </div>
            </div>
          </div>
        }
        <table className="table table-striped table-condensed">
          <thead>
            <tr>
              <th style={{width: '20px'}}></th>
              <th><Translate value="create.Name"/></th>
              <th><Translate value="create.Prefix"/></th>
            </tr>
          </thead>
          <tbody>
            { filteredCompanies.map(company => (
              <tr key={company._id} onClick={ () => selectCompany(company._id) }>
                <td><input type="checkbox" checked={ selected.indexOf(company._id) >= 0 }
                            onChange={ () => selectCompany(company._id)}/></td>
                <td><Link to={`/company/${company._id}`}>{company.name}</Link></td>
                <td>{company.prefix}</td>
              </tr>
            ))}
          </tbody>
        </table>
        { showShowMore ? <div className="text-center "><a href="#" onClick={showMore}>{ I18n.t('users.showMore') }</a></div> : null }
      </div>
    </div>
  );
}

Companies.propTypes = {
  loading: PropTypes.bool,
  companies: PropTypes.array,
  fetchCompanies: PropTypes.func,
  deleteCompanies: PropTypes.func, // Added missing prop validation
  exportCompanies: PropTypes.func, // Added missing prop validation
  exportAll: PropTypes.func, // Added missing prop validation
  importFile: PropTypes.func, // Added missing prop validation
};

const mapStateToProps = state => ({
  loading: state.companies.loading,
  companies: state.companies.data,
  filter: state.companies.filter,
});

const mapDispatchToProps = {
  fetchCompanies: fetchCompaniesAction,
  exportAll: exportAllAction,
  exportCompanies: exportCompaniesAction,
  importFile: importFileAction,
  deleteCompanies: deleteCompaniesAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Companies);
